export const TAGS_SELECTION_LOGIC_INCLUDE = "TAGS_SELECTION_LOGIC_INCLUDE";
export const TAGS_SELECTION_LOGIC_EXCLUDE = "TAGS_SELECTION_LOGIC_EXCLUDE";